import { requestFactory } from '@/utils/request';

export default requestFactory('/api/usercenter');
